import { render, staticRenderFns } from "./general-edit.vue?vue&type=template&id=c00ca534&scoped=true"
import script from "./general-edit.vue?vue&type=script&lang=js"
export * from "./general-edit.vue?vue&type=script&lang=js"
import style0 from "./general-edit.vue?vue&type=style&index=0&id=c00ca534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00ca534",
  null
  
)

export default component.exports